"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _selectors = require("settings-ui-sdk/Domains/selectors");

var _interactionsSelectors = require("../selectors/interactionsSelectors");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _constants = require("../constants");

var SitemapsRedirectContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SitemapsRedirectContainer, _PureComponent);

  function SitemapsRedirectContainer() {
    (0, _classCallCheck2.default)(this, SitemapsRedirectContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SitemapsRedirectContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(SitemapsRedirectContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.push("marketing/" + _UrlPathParams.DOMAINS + "/" + _constants.SITEMAPS_ROUTE + "/" + this.props.selectedDomain);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return SitemapsRedirectContainer;
}(_react.PureComponent);

SitemapsRedirectContainer.propTypes = {
  selectedDomain: _react.PropTypes.string,
  push: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var selectedDomain = (0, _interactionsSelectors.getDomainForSitemap)(state) || (0, _selectors.getAllDomains)(state).first().get('domain');
  return {
    selectedDomain: selectedDomain
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push
})(SitemapsRedirectContainer);

exports.default = _default;
module.exports = exports.default;